import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, TextInput, Button, Create, SimpleForm, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, NumberInput, BooleanInput, FunctionField, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, DateField, Filter, downloadCSV, DateInput, BooleanField } from 'react-admin';import jsonExport from 'jsonexport/dist';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import GavelIcon from '@material-ui/icons/Gavel';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { dateOnlyToCatalan, headersAPIDocAuth } from './../common/utils';  
import { apiUrl } from './../common/constants';

import { ExportButton } from './../components/ExportButton';

import { RenderBoolean } from '../components/User';

import { Link } from 'react-router-dom';

import { validateMaxLength } from './../components/Validator';

const yesNoLabel = value => value ? 'Sí' : 'No';
const attendanceLabel = record => yesNoLabel(record && (record.attendance || record.validated_at || Number(record.num_validations || 0) > 0));
const ticketPdfUrl = record => record ? `${apiUrl}/tickets_booking_items/${record.id}/pdf` : null;

const DownloadTicketPdfButton = ({ record }) => {
  const translate = useTranslate();

  const handleClick = async event => {
    event.stopPropagation();
    const url = ticketPdfUrl(record);
    if (!url) return;

    const response = await fetch(url, { headers: headersAPIDocAuth() });
    const blob = await response.blob();
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = 'entrada.pdf';
    link.click();
    window.URL.revokeObjectURL(href);
  };

  return record ? (
    <IconButton
      size="small"
      onClick={handleClick}
      title={translate('tickets_booking_items.download_pdf')}
      aria-label={translate('tickets_booking_items.download_pdf')}
    >
      <PictureAsPdfIcon fontSize="small" />
    </IconButton>
  ) : null;
};

export const TicketsBookingItemsList = (props) => {
  const translate = useTranslate();  
    
  let basePath='/tickets_booking_items'; 
  let resource = 'tickets_booking_items';
  let strRedirect = 'tickets_booking_items';
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ associations_id : localStorage.getItem('associations_id') }}  
        actions={props.show ?  <span/> : <ListActions />}    
        empty={props.show ?  <span/> : <ListActions />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'id', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={props.show ?  <span/> : <MyFilter />} 
        filterDefaultValues={ { q: "" }}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<TicketsBookingItemsDetails />} >  
          <Avatar><GavelIcon/></Avatar>                                  
          <TextField source="tickets_booking_id" label={translate('tickets_booking_items.tickets_booking_id')} sortable={false} />  
          <TextField source="booking_reference" label={translate('tickets_booking_items.booking_reference')} sortable={false} />  
          <TextField source="events_sessions_id" label={translate('tickets_booking_items.events_sessions_id')} sortable={false} />  
          <TextField source="events_sessions_prices_id" label={translate('tickets_booking_items.events_sessions_prices_id')} sortable={false} />  
          <TextField source="event_name" label={translate('tickets_booking_items.event_name')} sortable={false} />  
          <TextField source="session_name" label={translate('tickets_booking_items.session_name')} sortable={false} />  
          <DateField source="session_date_start" label={translate('tickets_booking_items.session_date_start')} sortable={false} />  
          <DateField source="session_date_finish" label={translate('tickets_booking_items.session_date_finish')} sortable={false} />  
          <TextField source="venue_name" label={translate('tickets_booking_items.venue_name')} sortable={false} />  
          <TextField source="venue_address" label={translate('tickets_booking_items.venue_address')} sortable={false} />  
          <TextField source="prices_name" label={translate('tickets_booking_items.prices_name')} sortable={false} />  
          <TextField source="ticket_code" label={translate('tickets_booking_items.ticket_code')} sortable={false} />  
          <BooleanField source="requires_id_check" label={translate('tickets_booking_items.requires_id_check')} sortable={false} />  
          <DateField source="validated_at" label={translate('tickets_booking_items.validated_at')} sortable={false} />  
          <TextField source="validated_by" label={translate('tickets_booking_items.validated_by')} sortable={false} />  
          <DateField source="unvalidated_at" label={translate('tickets_booking_items.unvalidated_at')} sortable={false} />  
          <TextField source="unvalidated_by" label={translate('tickets_booking_items.unvalidated_by')} sortable={false} />  
          <FunctionField source="attendance" label={translate('tickets_booking_items.attendance')} sortable={false} render={record => attendanceLabel(record)} />  
          <TextField source="price_base" label={translate('tickets_booking_items.price_base')} sortable={false} />  
          <TextField source="price_service_fee" label={translate('tickets_booking_items.price_service_fee')} sortable={false} />  
          <TextField source="price_total" label={translate('tickets_booking_items.price_total')} sortable={false} />  
          <TextField source="tax_event_percent" label={translate('tickets_booking_items.tax_event_percent')} sortable={false} />  
          <TextField source="tax_service_percent" label={translate('tickets_booking_items.tax_service_percent')} sortable={false} />  
          <TextField source="seat_access" label={translate('tickets_booking_items.seat_access')} sortable={false} />  
          <TextField source="seat_zone" label={translate('tickets_booking_items.seat_zone')} sortable={false} />  
          <TextField source="seat_row" label={translate('tickets_booking_items.seat_row')} sortable={false} />  
          <TextField source="seat_number" label={translate('tickets_booking_items.seat_number')} sortable={false} />  
          <TextField source="seat_label" label={translate('tickets_booking_items.seat_label')} sortable={false} />  
          <DateField source="created_at" label={translate('tickets_booking_items.created_at')} sortable={false} />  
          <DateField source="updated_at" label={translate('tickets_booking_items.updated_at')} sortable={false} />  
          <FunctionField label="Entrada" sortable={false} render={record => <DownloadTicketPdfButton record={record} />} />
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const TicketsBookingItemsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={4}>   
          <TextFieldShow source={record.tickets_booking_id} label={translate('tickets_booking_items.tickets_booking_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.booking_reference} label={translate('tickets_booking_items.booking_reference')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.events_sessions_id} label={translate('tickets_booking_items.events_sessions_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.events_sessions_prices_id} label={translate('tickets_booking_items.events_sessions_prices_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.event_name} label={translate('tickets_booking_items.event_name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.session_name} label={translate('tickets_booking_items.session_name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.session_date_start)} label={translate('tickets_booking_items.session_date_start')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.session_date_finish)} label={translate('tickets_booking_items.session_date_finish')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.venue_name} label={translate('tickets_booking_items.venue_name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.venue_address} label={translate('tickets_booking_items.venue_address')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.prices_name} label={translate('tickets_booking_items.prices_name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.ticket_code} label={translate('tickets_booking_items.ticket_code')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={<RenderBoolean source={record.requires_id_check} />} label={translate('tickets_booking_items.requires_id_check')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.validated_at)} label={translate('tickets_booking_items.validated_at')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.validated_by} label={translate('tickets_booking_items.validated_by')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.unvalidated_at)} label={translate('tickets_booking_items.unvalidated_at')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.unvalidated_by} label={translate('tickets_booking_items.unvalidated_by')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={attendanceLabel(record)} label={translate('tickets_booking_items.attendance')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_base} label={translate('tickets_booking_items.price_base')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_service_fee} label={translate('tickets_booking_items.price_service_fee')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_total} label={translate('tickets_booking_items.price_total')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.tax_event_percent} label={translate('tickets_booking_items.tax_event_percent')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.tax_service_percent} label={translate('tickets_booking_items.tax_service_percent')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.seat_access} label={translate('tickets_booking_items.seat_access')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.seat_zone} label={translate('tickets_booking_items.seat_zone')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.seat_row} label={translate('tickets_booking_items.seat_row')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.seat_number} label={translate('tickets_booking_items.seat_number')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.seat_label} label={translate('tickets_booking_items.seat_label')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.created_at)} label={translate('tickets_booking_items.created_at')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.updated_at)} label={translate('tickets_booking_items.updated_at')} />
        </Grid> 
      </Grid>
      
    </div>
  );
};

const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: item.id,
        tickets_booking_id: item.tickets_booking_id,
        booking_reference: item.booking_reference,
        events_sessions_id: item.events_sessions_id,
        events_sessions_prices_id: item.events_sessions_prices_id,
        event_name: item.event_name,
        session_name: item.session_name,
        session_date_start: dateOnlyToCatalan(item.session_date_start),
        session_date_finish: dateOnlyToCatalan(item.session_date_finish),
        venue_name: item.venue_name,
        venue_address: item.venue_address,
        prices_name: item.prices_name,
        ticket_code: item.ticket_code,
        requires_id_check: item.requires_id_check,
        validated_at: dateOnlyToCatalan(item.validated_at),
        validated_by: item.validated_by,
        unvalidated_at: dateOnlyToCatalan(item.unvalidated_at),
        unvalidated_by: item.unvalidated_by,
        attendance: attendanceLabel(item),
        price_base: item.price_base,
        price_service_fee: item.price_service_fee,
        price_total: item.price_total,
        tax_event_percent: item.tax_event_percent,
        tax_service_percent: item.tax_service_percent,
        seat_access: item.seat_access,
        seat_zone: item.seat_zone,
        seat_row: item.seat_row,
        seat_number: item.seat_number,
        seat_label: item.seat_label,
        created_at: dateOnlyToCatalan(item.created_at),
        updated_at: dateOnlyToCatalan(item.updated_at),
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id','tickets_booking_id'
,'booking_reference'
,'events_sessions_id'
,'events_sessions_prices_id'
,'event_name'
,'session_name'
,'session_date_start'
,'session_date_finish'
,'venue_name'
,'venue_address'
,'prices_name'
,'ticket_code'
,'requires_id_check'
,'validated_at'
,'validated_by'
,'unvalidated_at'
,'unvalidated_by'
,'attendance'
,'price_base'
,'price_service_fee'
,'price_total'
,'tax_event_percent'
,'tax_service_percent'
,'seat_access'
,'seat_zone'
,'seat_row'
,'seat_number'
,'seat_label'
,'created_at'
,'updated_at'
],
    rename: [translate('common.id'),translate('tickets_booking_items.tickets_booking_id'),translate('tickets_booking_items.booking_reference'),translate('tickets_booking_items.events_sessions_id'),translate('tickets_booking_items.events_sessions_prices_id'),translate('tickets_booking_items.event_name'),translate('tickets_booking_items.session_name'),translate('tickets_booking_items.session_date_start'),translate('tickets_booking_items.session_date_finish'),translate('tickets_booking_items.venue_name'),translate('tickets_booking_items.venue_address'),translate('tickets_booking_items.prices_name'),translate('tickets_booking_items.ticket_code'),translate('tickets_booking_items.requires_id_check'),translate('tickets_booking_items.validated_at'),translate('tickets_booking_items.validated_by'),translate('tickets_booking_items.unvalidated_at'),translate('tickets_booking_items.unvalidated_by'),translate('tickets_booking_items.attendance'),translate('tickets_booking_items.price_base'),translate('tickets_booking_items.price_service_fee'),translate('tickets_booking_items.price_total'),translate('tickets_booking_items.tax_event_percent'),translate('tickets_booking_items.tax_service_percent'),translate('tickets_booking_items.seat_access'),translate('tickets_booking_items.seat_zone'),translate('tickets_booking_items.seat_row'),translate('tickets_booking_items.seat_number'),translate('tickets_booking_items.seat_label'),translate('tickets_booking_items.created_at'),translate('tickets_booking_items.updated_at')],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('tickets_booking_items.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};


const ListActions = (props) => {
    const translate = useTranslate(); 
    
    let filterExport = { 
        associations_id: localStorage.getItem('associations_id'),        
        q: props.filterValues && props.filterValues.q ? props.filterValues.q : ''
    };
    
    return (
    <TopToolbar>     
        <MyCreateButton {...props} />    
        <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={false} exporter={exporter} sort={{ field: 'id', order: 'DESC' }} /> 
    </TopToolbar>
    );
};

export const MyCreateButton = ({ users_id , ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('tickets_booking_items');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          redirect('/tickets_booking_items/' + data.id);
        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_booking_items.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_booking_items.create')}
      >
        <DialogTitle>{translate('tickets_booking_items.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id') }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>                                     
                  <Grid item xs={12}>                                               
                    <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
  let linkBack = '/tickets_booking_items';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const TicketsBookingItemsEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  let strRedirect =  `/tickets_booking_items/${id}`;    
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));        
    redirect('/tickets_booking_items');        
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={3}>   
            <TextInput fullWidth source="tickets_booking_id" label={translate('tickets_booking_items.tickets_booking_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="events_sessions_id" label={translate('tickets_booking_items.events_sessions_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="events_sessions_prices_id" label={translate('tickets_booking_items.events_sessions_prices_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="event_name" label={translate('tickets_booking_items.event_name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="session_name" label={translate('tickets_booking_items.session_name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="session_date_start" label={translate('tickets_booking_items.session_date_start')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="session_date_finish" label={translate('tickets_booking_items.session_date_finish')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="venue_name" label={translate('tickets_booking_items.venue_name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="venue_address" label={translate('tickets_booking_items.venue_address')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="prices_name" label={translate('tickets_booking_items.prices_name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="ticket_code" label={translate('tickets_booking_items.ticket_code')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <BooleanInput fullWidth source="requires_id_check" label={translate('tickets_booking_items.requires_id_check')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="validated_at" label={translate('tickets_booking_items.validated_at')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="validated_by" label={translate('tickets_booking_items.validated_by')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="unvalidated_at" label={translate('tickets_booking_items.unvalidated_at')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="unvalidated_by" label={translate('tickets_booking_items.unvalidated_by')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="status" label={translate('tickets_booking_items.status')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_base" label={translate('tickets_booking_items.price_base')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_service_fee" label={translate('tickets_booking_items.price_service_fee')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_total" label={translate('tickets_booking_items.price_total')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="tax_event_percent" label={translate('tickets_booking_items.tax_event_percent')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="tax_service_percent" label={translate('tickets_booking_items.tax_service_percent')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="seat_access" label={translate('tickets_booking_items.seat_access')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="seat_zone" label={translate('tickets_booking_items.seat_zone')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="seat_row" label={translate('tickets_booking_items.seat_row')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="seat_number" label={translate('tickets_booking_items.seat_number')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="seat_label" label={translate('tickets_booking_items.seat_label')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="created_at" label={translate('tickets_booking_items.created_at')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="updated_at" label={translate('tickets_booking_items.updated_at')}  />
                  </Grid> 
                  <Grid item xs={12}>   
                  </Grid> 
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = ({ id , ...props }) => {
    
  let redirect = '/tickets_booking_items';
    
    
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton redirect={redirect} mutationMode="pessimistic" />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});






export const TicketsBookingItemsCreate  = ({ id, ...props }) => {

  const translate = useTranslate();   
  const [info, setInfo] = useState();
    
  return (

    <Create {...props} >
      <SimpleForm 
        initialValues={{ associations_id: localStorage.getItem('associations_id') }}
        redirect="list"
      >                
        <Grid container spacing={2}>
          <Grid item xs={12}>                    
            <Typography variant="h5" className="grey">{translate('tickets_booking_items.create')}</Typography>
          </Grid>  
          <Grid item xs={11}>                    
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
          </Grid>          
        </Grid>   

      </SimpleForm> 
    </Create>
  );
};
